<template>
  <v-container v-if="access.includes(roles.stores)">
    <v-card
      class="mx-auto set-height"
    >
      <v-card-title>
        <div class="primary--text">
          Stores
        </div>
        <v-spacer />
        <v-col
          cols="12"
          sm="6"
          md="4"
        >
          <v-text-field
            v-model="search_input"
            append-icon="mdi-magnify"
            label="Search"
            class="menu-items"
            @keydown.enter="OnSearchInput"
          />
        </v-col>
        <!-- <v-btn
          color="primary"
          class="menu-items"
          @click="ShowNewStore()"
        >
          New Store
        </v-btn> -->
        <v-btn
          outlined
          class="mr-4"
          color="grey darken-2"
          @click="show_profit_center = true"
        >
          Profit Center
        </v-btn>
        <v-switch
          v-model="show_inactive"
          label="Show Inactive"
        />
      </v-card-title>
      <div>
        <v-data-table
          :headers="headers_stores"
          :items="stores"
          :loading="loading_stores"
          :disable-sort="true"
          :options.sync="options"
          :loading-text="loading_text"
          class="elevation-1 text-no-wrap dense-2"
        >
          <template v-slot:[`item.store_number`]="{ item }">
            {{ String(item.store_number).padStart(3, '0') }}
          </template>
          <!-- <template v-slot:[`item.actions`]="{ item }">
            <v-row
              align="center"
              justify="center"
            >
              <v-tooltip
                color="success"
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    dark
                    x-small
                    color="cyan"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="EditStore(item)"
                  >
                    <v-icon dark>
                      mdi mdi-pencil
                    </v-icon>
                  </v-btn>
                </template>
                <span>Edit Store</span>
              </v-tooltip>
              &nbsp;
              <v-tooltip
                v-if="show_inactive"
                color="error"
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    dark
                    x-small
                    color="error"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="DeleteStore(item)"
                  >
                    <v-icon dark>
                      mdi mdi-delete
                    </v-icon>
                  </v-btn>
                </template>
                <span>Delete Store</span>
              </v-tooltip>
            </v-row>
          </template> -->
        </v-data-table>
      </div>
    </v-card>
    <div class="py-3" />
    <!-- New store dialog -->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="show_new_store"
          width="40%"
          max-width="40%"
        >
          <v-form
            ref="new_store_form"
            lazy-validation
          >
            <v-card>
              <v-card-title class="text-left">
                <h2 class="primary--text">
                  New Store
                </h2>
              </v-card-title>
              <v-card-text>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    ref="store_number"
                    v-model="new_store.store_number"
                    :counter="5"
                    label="Store Number"
                    :rules="[
                      v => !!v || 'This is required',
                      v => v.length ==0 || (v.length > 2 && v.length <= 5 && /^\d*$/.test(v)) || 'At least 3-5 characters long, all numeric.'
                    ]"
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-select
                    ref="profitcenter"
                    v-model="new_store.uid"
                    label="Profit Center"
                    :items="profit_centers"
                    :item-text="(item) => {return item.department+ ' - ' + item.description}"
                    item-value="uid"
                    :loading="loading_profit_centers"
                    :rules="[
                      v => !!v || 'This is required'
                    ]"
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="new_store.store_name"
                    label="Store Name"
                    :rules="[
                      v => !!v || 'This is required',
                      v => !!v && v.length <= 50 || 'Max input of 50 characters only.'
                    ]"
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-select
                    v-model="new_store.ownership"
                    label="Ownership"
                    :items="['McOpCo', 'Franchise', 'Joint Venture']"
                    :rules="[
                      v => !!v || 'This is required'
                    ]"
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-select
                    v-model="new_store.status"
                    label="Status"
                    :items="['Active']"
                    :rules="[
                      v => !!v || 'This is required'
                    ]"
                  />
                </v-col>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="green darken-1"
                  text
                  @click="SaveNewStore()"
                >
                  Save
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="show_new_store = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-row>
    </template>
    <!-- End new store dialog -->

    <!-- Edit store dialog -->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="show_edit_store"
          width="40%"
          max-width="40%"
        >
          <v-form
            ref="edit_store_form"
            lazy-validation
          >
            <v-card>
              <v-card-title class="text-left">
                <h2 class="primary--text">
                  Edit Store
                </h2>
              </v-card-title>
              <v-card-text>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    ref="store_number"
                    v-model="edited_store.store_number"
                    disabled
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-select
                    ref="profitcenter"
                    v-model="edited_store.uid2"
                    label="Profit Center"
                    :items="profit_centers"
                    :item-text="(item) => {return item.department+ ' - ' + item.description}"
                    item-value="uid"
                    :loading="loading_profit_centers"
                    :rules="[
                      v => !!v || 'This is required'
                    ]"
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="edited_store.store_name"
                    label="Store Name"
                    :rules="[
                      v => !!v || 'This is required',
                      v => !!v && v.length <= 50 || 'Max input of 50 characters only.'
                    ]"
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-select
                    v-model="edited_store.ownership"
                    label="Ownership"
                    :items="['McOpCo', 'Franchise', 'Joint Venture']"
                    :rules="[
                      v => !!v || 'This is required'
                    ]"
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-select
                    v-model="edited_store.status"
                    label="Status"
                    :items="['Active','Inactive']"
                    :rules="[
                      v => !!v || 'This is required'
                    ]"
                  />
                </v-col>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="green darken-1"
                  text
                  @click="UpdateStore()"
                >
                  Save
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="show_edit_store = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-row>
    </template>
    <!-- End new store dialog -->

    <!-- Profit center dialog -->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="show_profit_center"
          width="80%"
          max-width="80%"
        >
          <v-card>
            <v-card-title class="text-left">
              <v-row>
                <h2 class="primary--text">
                  Profit Center
                </h2>
                <v-spacer />
                <!-- <v-col
                  cols="6"
                  sm="6"
                  md="4"
                  class="text-right"
                >
                  <v-btn
                    color="primary"
                    class="menu-items"
                    @click="show_new_profit_center = true"
                  >
                    New
                  </v-btn>
                </v-col> -->
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="headers_profit_center"
                :items="profit_centers"
                :disable-sort="true"
                :loading="loading_profit_centers"
                :loading-text="loading_text"
                class="elevation-1 text-no-wrap"
              >
                <!-- <template v-slot:[`item.actions`]="{ item }">
                  <div class="row">
                    <v-btn
                      small
                      color="primary"
                      :disabled="item.email !== null"
                      @click.stop="SelectUser(item)"
                    >
                      Delete
                    </v-btn>
                  </div>
                </template> -->
              </v-data-table>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                color="green darken-1"
                text
                @click="show_profit_center = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!-- End profit center dialog -->
    <confirm ref="confirm" />
  </v-container>
</template>
<script>
  import {
    mapState,
  } from 'vuex'
  import {
    GetStores,
    GetProfitCenters,
    CreateStore,
    UpdateStore,
    DeleteStore,
  } from '@/graphql/Store.gql'
  export default {
    components: {
      Confirm: () => import('@/views/dashboard/component/Confirm'),
    },
    data () {
      return {
        // rebuild
        stores: [],
        loading_stores: true,
        skip_stores: true,
        loading_text: 'Please wait while loading data...',
        headers_stores: [
          { text: 'Store Number', value: 'store_number', class: 'title' },
          { text: 'Store Name', value: 'store_name', class: 'title' },
          { text: 'Profit Center', value: 'profit_center', class: 'title' },
          { text: 'Ownership', value: 'ownership', class: 'title' },
          { text: 'Status', value: 'status', class: 'title' },
        ],
        headers_profit_center: [
          { text: 'Department', value: 'department', class: 'title' },
          { text: 'Description', value: 'description', class: 'title' },
        ],
        profit_centers: [],
        loading_profit_centers: false,
        skip_profit_centers: true,
        stores_hash: '',
        options: {
          page: 1,
          itemsPerPage: 10,
        },
        show_new_store: false,
        show_edit_store: false,
        new_store: {},
        edited_store: {},
        show_profit_center: false,
        show_new_profit_center: false,
        show_inactive: false,
        search: '',
        search_input: '',
      }
    },
    computed: {
      ...mapState(['in_process', 'default_error', 'access', 'roles']),
    },
    watch: {
      options: {
        handler () {
          this.GetStores()
        },
        deep: true,
      },
      show_inactive: {
        handler () {
          this.GetStores()
        },
        deep: true,
      },
    },
    mounted () {
      window.scrollTo(0, 0)
      if (this.access.includes(this.roles.stores)) {
        this.GetStores()
        this.GetProfitCenters()
      }
      this.SetNewStoreData()
    },
    methods: {
      OnSearchInput () {
        this.search = this.search_input
        this.options.page = 1
        this.GetStores()
      },
      DeleteStore (item) {
        this.$refs.confirm.open('Please Confirm!', 'You are going to delete this store!', { color: 'red' })
          .then((confirm) => {
            if (confirm) {
              this.$store.commit('Notify', 'Deleting data...')
              this.$apollo.mutate({
                mutation: DeleteStore,
                variables: {
                  uid: item.uid,
                  hash: this.stores_hash,
                },
              }).then((res) => {
                if (res.data.DeleteStore.status === 'Ok') {
                  this.GetStores()
                  this.$store.commit('CloseAlert', '')
                } else if (res.data.DeleteStore.status === '0') {
                  this.CheckError({ message: 'Session expired!' })
                } else {
                  this.$store.commit('ShowError', res.data.DeleteStore.status)
                }
              }).catch(error => {
                this.CheckError(error)
              })
            }
          })
      },
      SaveNewStore () {
        if (!this.$refs.new_store_form.validate()) {
          this.$store.commit('ShowError', 'Please check your input!')
          return
        }
        this.new_store.hash = this.profit_centers_hash
        this.$store.commit('Notify', 'Creating record...')
        this.$apollo.mutate({
          mutation: CreateStore,
          variables: {
            input: this.new_store,
          },
        }).then((res) => {
          if (res.data.CreateStore.status === 'Ok') {
            this.SetNewStoreData()
            this.GetStores()
            this.$refs.new_store_form.resetValidation()
            this.show_new_store = false
            this.$store.commit('CloseAlert', '')
          } else if (res.data.CreateStore.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.CreateStore.status)
          }
        }).catch(error => {
          this.CheckError(error)
        })
      },
      UpdateStore () {
        if (!this.$refs.edit_store_form.validate()) {
          this.$store.commit('ShowError', 'Please check your input!')
          return
        }
        this.$store.commit('Notify', 'Saving data...')
        var input = JSON.parse(JSON.stringify(this.edited_store))
        delete input.__typename
        delete input.profit_center
        delete input.department
        this.$apollo.mutate({
          mutation: UpdateStore,
          variables: {
            input: input,
          },
        }).then((res) => {
          if (res.data.UpdateStore.status === 'Ok') {
            this.GetStores()
            this.$refs.edit_store_form.resetValidation()
            this.show_edit_store = false
            this.$store.commit('CloseAlert', '')
          } else if (res.data.UpdateStore.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.UpdateStore.status)
          }
        }).catch(error => {
          this.CheckError(error)
        })
      },
      SetNewStoreData () {
        this.new_store = {
          uid: '',
          store_number: '',
          store_name: '',
          ownership: '',
          status: 'Active',
        }
      },
      EditStore (item) {
        this.edited_store = JSON.parse(JSON.stringify(item))
        this.edited_store.store_number = String(this.edited_store.store_number).padStart(3, '0')
        this.edited_store.hash = this.stores_hash
        this.edited_store.uid2 = ''
        this.edited_store.hash2 = this.profit_centers_hash
        var p = this.profit_centers.filter(function (i) {
          return (
            i.department === item.department
          )
        })
        if (p.length === 1) { this.edited_store.uid2 = p[0].uid }
        this.show_edit_store = true
      },
      ShowNewStore () {
        if (!this.access.includes(this.roles.stores_manage)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.show_new_store = true
      },
      GetStores () {
        this.loading_stores = true
        this.stores = []
        this.skip_stores = false
        this.$apollo.queries.GetStores.refetch()
      },
      GetProfitCenters () {
        this.loading_profit_centers = true
        this.profit_centers = []
        this.skip_profit_centers = false
        this.$apollo.queries.GetProfitCenters.refetch()
      },
    },
    apollo: {
      GetStores: {
        error (error) {
          this.loading_stores = false
          this.CheckError(error)
        },
        query: GetStores,
        variables () {
          return {
            per_page: this.options.itemsPerPage || 10,
            page: this.options.page || 1,
            search: this.search,
            active: !this.show_inactive,
          }
        },
        skip () {
          return this.skip_stores
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetStores) {
              if (data.GetStores.status === 'Ok') {
                this.stores = data.GetStores.data
                this.stores_hash = data.GetStores.hash
              } else if (data.GetStores.status === '0') {
                this.CheckError({ message: 'Session expired!' })
              } else {
                this.$store.commit('ShowError', data.GetStores.status)
              }
              this.loading_stores = false
              this.skip_stores = true
            }
          }
        },
      },
      GetProfitCenters: {
        error (error) {
          this.loading_profit_centers = false
          this.CheckError(error)
        },
        query: GetProfitCenters,
        variables () {
          return {
          }
        },
        skip () {
          return this.skip_profit_centers
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetProfitCenters.status === 'Ok') {
              this.profit_centers = data.GetProfitCenters.data
              this.profit_centers_hash = data.GetProfitCenters.hash
            } else if (data.GetProfitCenters.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            } else {
              this.$store.commit('ShowError', data.GetProfitCenters.status)
            }
            this.loading_profit_centers = false
            this.skip_profit_centers = true
          }
        },
      },
    },
  }
</script>
